// Docs
// https://marmelab.com/react-admin/Show.html#actions
// https://github.com/marmelab/react-admin/blob/master/docs/Actions.md
// https://reactjs.org/docs/conditional-rendering.html

import React from 'react';
import {
  TextInput,
} from 'react-admin';
import ListHeaderWithFilters from '../../../../../components/ListHeaderWithFilters';

const ListHeader = ({createUrl, ...rest}) => (
  <ListHeaderWithFilters
    {...rest}
    title="Consent Items"
    subtitle="Here you can create a new Consent Item or change one of your existing Consent Items."
    createBtnLabel="consent_item_create"
    createBtnLabelSmall="consent_item_create_small"
    customUrl={createUrl}>
    <TextInput
      label="Search by consent item"
      source="name"
      alwaysOn
      fullWidth={true}
    />
  </ListHeaderWithFilters>
)

export default ListHeader;
